import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Form, Row} from 'react-bootstrap';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import "./CSVDownloadDialog.css";
import { useGovernment } from 'contexts/GovernmentContext';

const propTypes={
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onDownload: PropTypes.func
};
const defaultProps={
  isOpen: false,
  onClose: () => {},
  onDownload: ()=>{}
};
const CSVDownloadDialog = (props) => {
  const { isOpen, onClose, onDownload } = props;
  const [selectedTime, setSelectedTime] = useState('');
  const [selectedMode, setSelectedMode] = React.useState('年間');
  const { government } = useGovernment();

  const handleModeChange = (event, newMode) => {
    setSelectedMode(newMode);
    setSelectedTime('');
  };

  // 選択可能な月リストを生成
  const getMonthOptions = () => {
    const options = [];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const startingDate = new Date(government.createdAt);
    const startYear = startingDate.getFullYear();
    const startMonth = startingDate.getMonth() + 1;

    for (let year = startYear; year <= currentYear; year++) {
      const start = (year === startYear) ? startMonth : 1;
      const end = (year === currentYear) ? currentMonth : 12;

      for (let month = start; month <= end; month++) {
        const monthStr = month < 10 ? `0${month}` : `${month}`;
        options.push({
          value: `${year}-${monthStr}`,
          label: `${year}年${monthStr}月`
        });
      }
    }

    return options.reverse(); // 新しい月を上に表示
  };

  // 選択可能な年リストを生成
  const getYearOptions = () => {
    const options = [];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    const startingDate = new Date(government.createdAt);
    const startYear = startingDate.getFullYear();

    for (let year = startYear; year <= currentYear; year++) {
      options.push({
        value: `${year}`,
        label: `${year}年`
      });
    }

    return options.reverse(); // 新しい年を上に表示
  };

  const handleDownload = () => {
    if (selectedTime) {
      onDownload(selectedTime);
    }
  };

  if (!isOpen) return null;
  return <div
    className="modal show"
    style={{ display: 'block', position: 'absolute' }}>
    <Modal.Dialog className="p-0">
      <Modal.Header closeButton onHide={onClose}>
        <Modal.Title>CSVダウンロード</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          maxHeight: '256px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }}>
        <Form.Group>
          <Form.Label>ダウンロード対象年・月</Form.Label>
          <Row className='ml-1 mb-2'>
            <ToggleButtonGroup
              color="primary"
              value={selectedMode}
              exclusive
              onChange={handleModeChange}
              aria-label="Selection Mode"
              sx={{
                '& .MuiToggleButton-root': {
                  border: 1,
                  borderColor: 'divider',      // thin grey line
                  '&.Mui-selected': {
                    bgcolor: 'transparent',    // keep it hollow
                    borderColor: 'primary.main',
                    color: 'primary.main',
                  },
                  '&:hover': {
                    bgcolor: 'action.hover',
                  },
                },
              }}
            >
              <ToggleButton value="年間">年間</ToggleButton>
              <ToggleButton value="月間">月間</ToggleButton>
            </ToggleButtonGroup>
          </Row>  
          <Form.Control
            as="select"
            value={selectedTime}
            onChange={(e) => setSelectedTime(e.target.value)}
            className="csv_download_dialog_input">

            {selectedMode === "年間" ? (
              <>
                <option value="">年を選択してください</option>
                {getYearOptions().map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </>
            ) : (
              <>
                <option value="">月を選択してください</option>
                {getMonthOptions().map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </>
            )}
          </Form.Control>        
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-end">
        <Button
          className="btn-outline btn-wd mr-1"
          variant="default"
          onClick={onClose}>
          キャンセル
        </Button>
        <Button
          className="btn-outline btn-wd mr-1"
          variant="primary"
          disabled={!selectedTime}
          onClick={handleDownload}>
          ダウンロード
        </Button>
      </Modal.Footer>
    </Modal.Dialog>
  </div>
}
CSVDownloadDialog.propTypes = propTypes;
CSVDownloadDialog.defaultProps = defaultProps;
export default CSVDownloadDialog;
